export const adminReducer = (adminDetail = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case "USER_LOGGED_IN":
      return {
        ...adminDetail,
        userId: payload,
      };
    case "LOGOUT":
      localStorage.clear();
      return {
        userId: null,
      };
    default:
      return adminDetail;
  }
};
